module.exports = __webpack_public_path__ + "img/Character_Aether_Thumb.edf6542a.png";